// psicoid.js — conteúdo da página /apps/psicoid.
// As capturas vêm de tools/psicoid-capturas (app: telas reconstruídas com os tokens do app;
// web: o painel de verdade rodando contra uma API fictícia). Todos os nomes e valores nas telas são fictícios.
import appHome from '../assets/psicoid/app/home.webp';
import appSchedule from '../assets/psicoid/app/schedule.webp';
import appSeries from '../assets/psicoid/app/series-review.webp';
import appPatients from '../assets/psicoid/app/my-patients.webp';
import appPatientProfile from '../assets/psicoid/app/patient-profile.webp';
import appRecords from '../assets/psicoid/app/session-records.webp';
import appRecordEditor from '../assets/psicoid/app/session-record-editor.webp';
import appFinancial from '../assets/psicoid/app/financial-dashboard.webp';
import appStatement from '../assets/psicoid/app/financial-statement.webp';
import appProfile from '../assets/psicoid/app/profile.webp';
import appProfilePreview from '../assets/psicoid/app/profile-preview.webp';
import appShare from '../assets/psicoid/app/to-share.webp';
import appFind from '../assets/psicoid/app/find-psychologist.webp';
import appTimes from '../assets/psicoid/app/select-times.webp';
import appConfirm from '../assets/psicoid/app/select-times-confirm.webp';
import appSuccess from '../assets/psicoid/app/to-schedule-success.webp';
import appMyAgenda from '../assets/psicoid/app/my-agenda.webp';
import webInicio from '../assets/psicoid/web/inicio.webp';
import webInicioEscuro from '../assets/psicoid/web/inicio-escuro.webp';
import webAgenda from '../assets/psicoid/web/agenda.webp';
import webCriarAgenda from '../assets/psicoid/web/criar-agenda.webp';
import webPacientes from '../assets/psicoid/web/pacientes.webp';
import webProntuario from '../assets/psicoid/web/prontuario.webp';
import webRegistros from '../assets/psicoid/web/registros.webp';
import webFinanceiro from '../assets/psicoid/web/financeiro.webp';
import webCartao from '../assets/psicoid/web/cartao.webp';
import webPerfilPublico from '../assets/psicoid/web/perfil-publico.webp';
import webLanding from '../assets/psicoid/web/landing.webp';

export const LINKS = {
  site: 'https://psicoid.com.br',
  appStore: 'https://apps.apple.com/br/app/psicoid/id6739891237',
  googlePlay: 'https://play.google.com/store/apps/details?id=com.digitalinspires.psicoid&hl=pt_BR',
};

export const HERO_SHOTS = { phone: appHome, browser: webInicio };

export const FACTS = [
  { label: 'Plataformas', value: 'iOS, Android e Web' },
  { label: 'Para quem', value: 'Psicólogas, psicólogos e seus pacientes' },
  { label: 'Modelo', value: 'Gratuito para profissionais' },
  { label: 'Nosso papel', value: 'Do design ao backend' },
];

export const BEFORE = [
  'Trocas infinitas de mensagem para marcar uma sessão',
  'Cadernos, planilhas e post-its espalhados',
  'Faltas frequentes, sem aviso prévio',
  'Histórico do paciente em pedaços',
  'A profissional vira a secretária da própria agenda',
];

export const AFTER = [
  'O paciente agenda sozinho nos horários livres',
  'A rotina clínica inteira num único lugar',
  'Lembrete automático antes de cada sessão',
  'Registro de sessão pronto depois da consulta, com exportação em PDF',
  'Link e QR Code para convidar pacientes em um toque',
];

// Como funciona: do cadastro à sessão marcada.
export const STEPS = [
  {
    n: '01',
    title: 'Monta o perfil',
    desc: 'CRP, abordagens, especialidades, modalidade e endereço. É a página que o paciente vê antes de escolher.',
    img: appProfile,
    alt: 'Tela Meu perfil do app PsicoID, com CRP, abordagens terapêuticas e apresentação',
  },
  {
    n: '02',
    title: 'Abre a agenda',
    desc: 'Dias, horários e duração das sessões, com antecedência mínima para agendar e prazo para cancelar.',
    img: appSchedule,
    alt: 'Tela Minha agenda do app PsicoID, com consultas e horários vagos do dia',
  },
  {
    n: '03',
    title: 'Convida os pacientes',
    desc: 'Um link e um QR Code levam direto ao perfil. Basta mandar para quem já é atendido.',
    img: appShare,
    alt: 'Tela Cartão de visita do app PsicoID, com link público e QR Code',
  },
  {
    n: '04',
    title: 'O paciente agenda sozinho',
    desc: 'Ele escolhe um horário livre no app. A profissional só recebe a notificação, e os dois são lembrados antes da sessão.',
    img: appConfirm,
    alt: 'Tela de confirmação de agendamento vista pelo paciente no app PsicoID',
  },
];

// Tour do app, lado da profissional.
export const PSY_TOUR = [
  {
    id: 'home',
    title: 'Início do dia',
    desc: 'O app abre no dia de trabalho: quantas sessões há hoje, qual já terminou e espera conclusão, e atalhos para agenda, pacientes e consultas.',
    img: appHome,
    alt: 'Tela inicial da psicóloga no app PsicoID',
  },
  {
    id: 'schedule',
    title: 'Agenda',
    desc: 'Consultas, horários vagos, bloqueios e recorrências na mesma linha do tempo. Abrir, bloquear ou encaixar um horário avulso leva um toque.',
    img: appSchedule,
    alt: 'Tela Minha agenda do app PsicoID',
  },
  {
    id: 'series',
    title: 'Sessões recorrentes',
    desc: 'Para quem vem toda semana ou a cada quinze dias: a profissional revisa as datas, tira feriados e férias e agenda a série inteira de uma vez.',
    img: appSeries,
    alt: 'Tela Revisar sessões, com as datas de uma recorrência semanal',
  },
  {
    id: 'patients',
    title: 'Pacientes',
    desc: 'A carteira num lugar só: quem chegou pelo app, quem foi cadastrado pela profissional e quem está em acompanhamento.',
    img: appPatients,
    alt: 'Tela Meus pacientes do app PsicoID',
  },
  {
    id: 'patient',
    title: 'Perfil do paciente',
    desc: 'Próxima consulta, histórico, registros, prontuário e contato de cada paciente, com o WhatsApp a um toque.',
    img: appPatientProfile,
    alt: 'Tela Perfil do paciente no app PsicoID',
  },
  {
    id: 'records',
    title: 'Registros de sessão',
    desc: 'Depois de cada consulta, o registro é escrito num editor de texto rico. O histórico completo do paciente sai em PDF quando for preciso.',
    img: appRecordEditor,
    alt: 'Editor do registro de sessão no app PsicoID',
  },
  {
    id: 'financial',
    title: 'Financeiro',
    desc: 'O dinheiro não passa pelo PsicoID: a profissional registra o que recebeu e o app organiza o mês em recebido, a receber, previsto e pendências.',
    img: appFinancial,
    alt: 'Tela Financeiro do app PsicoID, com faturamento do mês e pendências',
  },
  {
    id: 'share',
    title: 'Cartão de visita',
    desc: 'Link público e QR Code do perfil, prontos para copiar, baixar ou compartilhar com quem já é paciente.',
    img: appShare,
    alt: 'Tela Cartão de visita do app PsicoID',
  },
];

// Tour do app, lado do paciente.
export const PATIENT_TOUR = [
  {
    id: 'find',
    title: 'Localizar',
    desc: 'Busca presencial por cidade ou online, por nome e por especialidade, ordenada por quem está mais perto. Também dá para ver no mapa.',
    img: appFind,
    alt: 'Tela Localizar psicólogos do app PsicoID',
  },
  {
    id: 'profile',
    title: 'Perfil da profissional',
    desc: 'CRP, abordagens terapêuticas, especialidades e apresentação, para conhecer quem atende antes de escolher.',
    img: appProfilePreview,
    alt: 'Perfil de uma psicóloga visto pelo paciente no app PsicoID',
  },
  {
    id: 'times',
    title: 'Escolher horário',
    desc: 'Os horários livres do dia separados em manhã, tarde e noite, já com valor, duração e modalidade.',
    img: appTimes,
    alt: 'Tela Escolher horário do app PsicoID',
  },
  {
    id: 'confirm',
    title: 'Confirmar',
    desc: 'Data, modalidade, valor e lembrete numa folha só, com espaço para deixar uma observação para a profissional.',
    img: appConfirm,
    alt: 'Folha de confirmação de agendamento no app PsicoID',
  },
  {
    id: 'success',
    title: 'Consulta agendada',
    desc: 'A confirmação traz o endereço do consultório ou o link da sessão online, e um atalho para a agenda.',
    img: appSuccess,
    alt: 'Tela Consulta agendada do app PsicoID',
  },
  {
    id: 'agenda',
    title: 'Minha agenda',
    desc: 'A próxima consulta em destaque e as seguintes organizadas por semana, com lembrete antes de cada uma.',
    img: appMyAgenda,
    alt: 'Tela Minha agenda vista pelo paciente no app PsicoID',
  },
];

// Tour do painel web (psicoid.com.br/dashboard).
export const WEB_TOUR = [
  {
    id: 'inicio',
    title: 'Início',
    url: 'psicoid.com.br/dashboard',
    desc: 'O dia de trabalho na tela grande: sessões de hoje, a que espera conclusão, notificações e pacientes recentes.',
    img: webInicio,
    alt: 'Tela Início do painel web do PsicoID',
  },
  {
    id: 'agenda',
    title: 'Agenda',
    url: 'psicoid.com.br/dashboard/calendar',
    desc: 'Semana ou dia, com consultas, horários disponíveis, bloqueios e recorrências na mesma grade.',
    img: webAgenda,
    alt: 'Agenda semanal do painel web do PsicoID',
  },
  {
    id: 'criar-agenda',
    title: 'Criar agenda',
    url: 'psicoid.com.br/dashboard/agenda',
    desc: 'Disponibilidades por período e dia da semana, valor da sessão e antecedência para agendar e cancelar.',
    img: webCriarAgenda,
    alt: 'Tela Criar agenda do painel web do PsicoID',
  },
  {
    id: 'pacientes',
    title: 'Pacientes',
    url: 'psicoid.com.br/dashboard/patients',
    desc: 'Totais da carteira, pacientes recentes e a lista completa, com busca e contato direto.',
    img: webPacientes,
    alt: 'Tela Meus Pacientes do painel web do PsicoID',
  },
  {
    id: 'prontuario',
    title: 'Prontuário',
    url: 'psicoid.com.br/dashboard/patients/prontuario',
    desc: 'Identificação, avaliação da demanda, plano de trabalho e encerramento, em etapas, com prévia em PDF.',
    img: webProntuario,
    alt: 'Prontuário de um paciente no painel web do PsicoID',
  },
  {
    id: 'registros',
    title: 'Registros',
    url: 'psicoid.com.br/dashboard/patients/records',
    desc: 'Os registros de sessão de cada paciente em ordem, com exportação do histórico em PDF.',
    img: webRegistros,
    alt: 'Registros de sessão no painel web do PsicoID',
  },
  {
    id: 'financeiro',
    title: 'Financeiro',
    url: 'psicoid.com.br/dashboard/financial',
    desc: 'Recebido no mês, a receber, previsto, faturamento dos últimos seis meses e as pendências para marcar como pagas.',
    img: webFinanceiro,
    alt: 'Tela Financeiro do painel web do PsicoID',
  },
  {
    id: 'cartao',
    title: 'Cartão de visita',
    url: 'psicoid.com.br/dashboard/share',
    desc: 'O link público, o QR Code e uma prévia de como o perfil aparece na busca do app.',
    img: webCartao,
    alt: 'Tela Cartão de visita do painel web do PsicoID',
  },
  {
    id: 'escuro',
    title: 'Tema escuro',
    url: 'psicoid.com.br/dashboard',
    desc: 'O painel inteiro tem versão escura, para quem fecha o dia de trabalho à noite.',
    img: webInicioEscuro,
    alt: 'Tela Início do painel web do PsicoID no tema escuro',
  },
];

export const PUBLIC_SHOTS = [
  {
    id: 'perfil',
    title: 'Perfil público',
    url: 'psicoid.com.br/perfil/marianacosta',
    desc: 'Cada profissional ganha uma página aberta em qualquer navegador. O QR Code leva o paciente para o app, já no perfil dela.',
    img: webPerfilPublico,
    alt: 'Página de perfil público de uma psicóloga em psicoid.com.br',
  },
  {
    id: 'site',
    title: 'Site e blog',
    url: 'psicoid.com.br',
    desc: 'A página que apresenta o produto, com caminhos separados para profissionais e pacientes, perguntas frequentes e blog.',
    img: webLanding,
    alt: 'Página inicial do site psicoid.com.br',
  },
];

// Todas as telas do app, para a faixa "uma linguagem só".
export const GALLERY = [
  { img: appHome, label: 'Início' },
  { img: appSchedule, label: 'Agenda' },
  { img: appSeries, label: 'Recorrência' },
  { img: appPatients, label: 'Pacientes' },
  { img: appPatientProfile, label: 'Perfil do paciente' },
  { img: appRecords, label: 'Registros' },
  { img: appRecordEditor, label: 'Editor' },
  { img: appFinancial, label: 'Financeiro' },
  { img: appStatement, label: 'Extrato' },
  { img: appProfile, label: 'Meu perfil' },
  { img: appShare, label: 'Cartão de visita' },
  { img: appFind, label: 'Localizar' },
  { img: appProfilePreview, label: 'Perfil da profissional' },
  { img: appTimes, label: 'Horários' },
  { img: appConfirm, label: 'Confirmar' },
  { img: appSuccess, label: 'Agendada' },
  { img: appMyAgenda, label: 'Agenda do paciente' },
];

// Cores do theme do app (psicoid-app/src/config/theme) e o papel de cada uma.
export const PALETTE = [
  { name: 'Azul PsicoID', hex: '#333BFF', role: 'Marca e ação principal', dark: true },
  { name: 'Verde', hex: '#1CD97F', role: 'Confirmado, pago, online' },
  { name: 'Creme', hex: '#F7F2E9', role: 'Fundo das telas' },
  { name: 'Marfim', hex: '#FFFCF6', role: 'Cartões e superfícies' },
  { name: 'Âmbar', hex: '#C97A1F', role: 'Pendências e avisos', dark: true },
  { name: 'Tinta', hex: '#0F1217', role: 'Texto', dark: true },
];

export const PRINCIPLES = [
  {
    title: 'Azul em cima, creme embaixo',
    desc: 'Toda tela nasce igual: cabeçalho azul chapado e um painel creme de cantos arredondados que encaixa por baixo. Quem aprende uma tela já sabe ler as outras.',
  },
  {
    title: 'Cor com função',
    desc: 'Azul é ação e marca. Verde só aparece no que deu certo: confirmado, pago, online. Âmbar marca o que espera uma decisão. Nenhuma cor é enfeite.',
  },
  {
    title: 'Calmo por padrão',
    desc: 'Tons de areia, linhas finas no lugar de sombras pesadas e bastante respiro. É um produto de saúde mental, e a interface não pode gritar.',
  },
  {
    title: 'A mesma língua no celular e no navegador',
    desc: 'App e painel web dividem tokens de cor, tipografia e vocabulário. A profissional troca de tela sem reaprender o produto.',
  },
];

export const STACK = [
  {
    title: 'App iOS e Android',
    desc: 'Um código só para as duas lojas, com notificações push, mapa, login com Google e Apple e atualizações sem passar pela loja.',
    tags: ['React Native', 'Expo', 'TypeScript', 'React Query', 'Reanimated', 'OneSignal', 'Sentry'],
  },
  {
    title: 'Painel web e site',
    desc: 'Área logada da profissional, perfis públicos, site e blog no mesmo projeto, com tema claro e escuro e layout responsivo.',
    tags: ['Next.js', 'React', 'TypeScript', 'Tailwind CSS', 'React Query', 'FullCalendar', 'Tiptap'],
  },
  {
    title: 'Backend e segurança',
    desc: 'API própria para os dois fronts. No web, a sessão vive em cookies httpOnly atrás de um proxy no servidor, fora do alcance de scripts da página.',
    tags: ['API própria', 'Sessão renovável', 'Cookies httpOnly', 'LGPD', 'Exclusão de conta pelo usuário'],
  },
];

export const DELIVERY = [
  'Design de produto e de interface',
  'App para iOS e Android',
  'Painel web, site e blog',
  'Backend e API',
  'Publicação e material das lojas',
  'Evolução contínua, versão após versão',
];
